<template>
  <div class="admin-field-line-items">
    <InvoiceLineItems :items="products" v-if="products.length" flattened />
    <v-alert v-else-if="!order.$isNew" outlined text
      >No Order Items found.</v-alert
    >
    <v-divider class="my-2" />
    <OrderMetaItems :order="order" />
  </div>
</template>

<script>
import OrderModel from '@/models/OrderModel'
import _get from 'lodash/get'

import OrderMetaItems from '@/components/OrderMetaItems'
import InvoiceLineItems from '@/components/InvoiceLineItems'

export default {
  name: 'AdminFieldLineItems',
  components: { InvoiceLineItems, OrderMetaItems },
  props: {
    order: {
      type: OrderModel,
      require: true,
      default: () => new OrderModel(),
    },
  },
  data() {
    return {
      error: null,
    }
  },
  computed: {
    products() {
      return _get(this.order, 'products', [])
    },
  },
}
</script>
